export default __webpack_public_path__ + "static/media/cross.5474152c.svg";